import './SingleSelect.less';
import React from 'react';
import {translate} from "../../i18n";
import Dropdown from "../dropdown/Dropdown";
import Icon from "../icon/Icon";

export default class SingleSelect extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            value: SingleSelect.normalizeValue(this.props.defaultValue),
            optionsDropdownShown: false
        };

        /**
         *
         * @type {HTMLDivElement}
         */
        this.componentEl = null;

        /** @type {HTMLDivElement} */
        this.inlineEl = null;
    }

    static getDerivedStateFromProps(props, state) {
        if (props.value !== undefined && props.value !== state.value) {
            state.value = SingleSelect.normalizeValue(props.value);
            return state;
        }
        return null;
    }

    static normalizeValue = (value) => {
        return value !== undefined ? value : null;
    };

    componentDidUpdate() {
        const {value} = this.state;
        /** @type {LabelMap} */
        const options = this.props.options;

        // check if value is in options or not
        // if not, set value to default value
        if (value !== null && !options.get(value)) {
            this.setValue(null);
        }
    }

    setValue = (value) => {
        const {onChange} = this.props;
        this.setState(
            {value},
            onChange ? () => onChange(value) : undefined
        );
    };

    toggleOptionsDropdown = () => {
        this.setState({
            optionsDropdownShown: !this.state.optionsDropdownShown
        });
    };

    closeOptionsDropdown = () => {
        if (this.state.optionsDropdownShown) {
            this.setState({
                optionsDropdownShown: false
            });
        }
    };

    render() {
        const {appearance, removable, disabled, dropdownHorizontalAlignment} = this.props;
        const {value, optionsDropdownShown} = this.state;
        /** @type {LabelMap} */
        const options = this.props.options;
        const selectedOption = options.get(value);
        return <div
            className={
                'single-select'
                + (disabled ? ' disabled' : '')
                + (appearance ? ` appearance-${appearance}` : '')
            }
            ref={el => this.componentEl = el}
        >
            <div className="inline"
                 onClick={() => disabled || this.toggleOptionsDropdown()}
                 ref={el => this.inlineEl = el}
            >
                <div className="selection">
                    {selectedOption ? selectedOption.label : <div className="prompt">{translate('Select one...')}</div>}
                </div>
                <div className="buttons">
                    {
                        !disabled &&
                        (
                            removable && value !== null
                                ? <button
                                    type="button"
                                    className="remove-button"
                                    onClick={ev => {
                                        ev.stopPropagation();
                                        this.setValue(null);
                                    }}
                                >
                                    <Icon name="times"/>
                                </button>
                                : <button
                                    type="button"
                                    className="caret-button"
                                >
                                    <Icon name="caret-down"/>
                                </button>
                        )
                    }
                </div>
            </div>
            {
                !disabled &&
                optionsDropdownShown &&
                <Dropdown
                    name="single-select"
                    opener={this.inlineEl}
                    close={this.closeOptionsDropdown}
                    horizontalAlignment={dropdownHorizontalAlignment}
                >
                    <div
                        className={(appearance ? ` appearance-${appearance}` : '')}
                        style={{
                            boxSizing: 'border-box',
                            minWidth: this.inlineEl.offsetWidth + 'px'
                        }}
                    >
                        <div className="dropdown-scroll-container">
                            <div className="dropdown-scroll-view">
                                <ul>
                                    {
                                        options.items.map(option => {
                                            return <li
                                                key={option.value}
                                                className={
                                                    (value === option.value ? ' selected' : '')
                                                }
                                                onClick={() => {
                                                    this.setValue(option.value);
                                                    this.closeOptionsDropdown();
                                                }}
                                            >
                                                {option.label}
                                            </li>;
                                        })
                                    }
                                </ul>
                            </div>
                        </div>
                    </div>
                </Dropdown>
            }
        </div>
    }
}
